















import {
  Vue, Component, Prop, Mixins, PropSync, Watch,
} from 'vue-property-decorator';
import { Doughnut, mixins, Bar } from 'vue-chartjs';
import Chart from 'chart.js';
import ChartsUtil from '@/util/ChartUtils';
import StatsUtil from '@/util/StatsUtil';

@Component({})
export default class UnitsChart extends Mixins(Doughnut) {
  @PropSync('unitLists', {}) unitList!: any;

  @PropSync('marketSelected', {}) selectedMarket!: any;

  private chart: any;

  mounted() {
    this.generateChart(this.unitList);
  }

  public generateChart(conf: any) {
    const ctx: any = document.getElementById('unit-chart');
    const unitLegendContainer = (this.$refs.unitLegend as any);
    const unitNoDataContainer = (this.$refs.unitNoData as any);
    if (ctx) {
      if (!conf) {
        const config = this.getChartConfig(this.unitList);
        if (this.chart) {
          this.chart.data.datasets = config.datasets;
          this.chart.data.labels = config.chartLabels;
        } else {
          this.chart = new Chart(
            ctx,
            ChartsUtil.generateChartData(config.chartLabels,
              config.datasets),
          );
          this.chart.options.animation = ChartsUtil
            .getChartAnimation(unitNoDataContainer, unitLegendContainer);
        }
      } else {
        const chartConfig = this.getChartConfig(conf);
        if (this.chart) {
          this.chart.data.datasets = chartConfig.datasets;
          this.chart.data.labels = chartConfig.chartLabels;
        } else {
          this.chart = new Chart(
            ctx,
            ChartsUtil.generateChartData(chartConfig.chartLabels,
              chartConfig.datasets),
          );
          this.chart.options.animation = ChartsUtil
            .getChartAnimation(unitNoDataContainer, unitLegendContainer);
        }
      }

      const myLegendContainer: any = document.getElementById('unit-legend');
      myLegendContainer.innerHTML = this.chart.generateLegend();
      this.chart.update();
    }
  }

  public getChartConfig(list: any) {
    const { data } = list;
    const chartData = data.datasets[0]?.data;
    const chartLabels = data.labels;
    const datasets = [{
      backgroundColor: ['#287dde', '#a0c0f6'],
      data: chartData,
    }];
    return {
      chartLabels,
      datasets,
    };
  }

  @Watch('unitLists')
  async checkUnitList(val: any) {
    this.generateChart(val);
  }
}
